import * as xss from 'xss';
import { decodeHTML } from 'entities';
import { Parser } from 'html-to-react';

// remove scripts and styles, allow links and images
const gentleFilter = new xss.FilterXSS({
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script', 'style'],
    whiteList: {
        a: ['alt', 'href', 'target'],
        b: [],
        br: [],
        font: ['size'],
        i: [],
        img: ['width', 'height', 'src', 'srcset', 'title'],
        li: [],
        ol: [],
        p: [],
        strong: [],
        table: [],
        td: [],
        tr: [],
        ul: [],
    },
});

// remove scripts, styles and images, allow links
const gentleOldFilter = new xss.FilterXSS({
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script', 'style', 'img'],
    whiteList: {
        a: ['alt', 'target'],
        b: [],
        br: [],
        font: [],
        i: [],
        li: [],
        ol: [],
        p: [],
        strong: [],
        table: [],
        td: [],
        tr: [],
        ul: [],
    },
});

// Create a filter for removing all the html in the case that we fail parsing
const bruteFilter = new xss.FilterXSS({
    stripIgnoreTag: true, // filter out all HTML not in the whilelist
    stripIgnoreTagBody: ['script', 'style'], // the script tag is a special case, we need to filter out its content
    // @ts-ignore
    whiteList: [], // empty, means filter out all tags
});

const htmlToReactParser = new Parser();
const cleanSpace = (text) => text.replace(/\s/g, ' ');

// remove all html and return a text string
const removeHtml = (text: string) => {
    let manuallyCleanedHtml = text || '';
    // Manually replace the HTML line breaks, as bruteFilter doesn't replace the removed HTML tags
    manuallyCleanedHtml = manuallyCleanedHtml.replace(/<br ?\/?>/g, ' ');
    // Manually replace line item tags, as bruteFilter doesn't replace the removed HTML tags
    manuallyCleanedHtml = manuallyCleanedHtml.replace(/<li>/g, ' ');
    let safeHtml = bruteFilter.process(manuallyCleanedHtml).trim();
    safeHtml = cleanSpace(safeHtml);
    return safeHtml;
};

// sanitize xss and return react elements
export const safelyRender = (html: string, wrapper: string = 'div', old?: boolean) => {
    const filter = old ? gentleOldFilter : gentleFilter;
    // first we will pull out all the non breaking spaces then we decode and process
    let safeHtml = filter.process(decodeHTML((html || '').replace(/\u00A0/g, ' '))).trim();

    try {
        const stringToTry = wrapper === '' ? safeHtml : `<${wrapper}>${safeHtml}</${wrapper}>`;
        safeHtml = htmlToReactParser.parse(stringToTry);
    } catch (e) {
        safeHtml = bruteFilter.process(html).trim();
    }
    return safeHtml;
};

// sanitizes meta data by removing HTML, and replaces whitespace characters with single spaces to improve readability
export const safelyEscapeText = (text: string) => {
    return decodeHTML(removeHtml(text)).replace(/\s\s+/g, ' ');
};
